export default __webpack_public_path__ + "assets/images/Images-a021dcd9073cfdbd36774ddd9185176a.svg";